import PropTypes from 'prop-types';

import FeaturedCard from '../cards/featuredCard';
import { pipe } from '../../utils/helpers';

const FeaturedContent = ({ headline, tiles }) => {
	const mapToTile = (item) => ({
		...item,
		image: {
			data: item?.icon?.gatsbyImageData,
			src: item?.icon?.file?.url,
			alt: item?.icon?.description,
		},
	});

	return (
		<div className="featured section">
			<div className="section__content">
				<h2 className="featured__title typography typography--h2 typography--secondary">
					{headline}
				</h2>
				<div className="featured__items">
					{tiles.map(
						pipe(mapToTile, (tile) => (
							<FeaturedCard key={tile.title} content={tile} />
						))
					)}
				</div>
			</div>
		</div>
	);
};

FeaturedContent.propTypes = {
	headline: PropTypes.string.isRequired,
	tiles: PropTypes.arrayOf(
		PropTypes.shape({
			icon: PropTypes.shape({
				gatsbyImageData: PropTypes.object,
				url: PropTypes.string,
				description: PropTypes.string,
			}),
			title: PropTypes.string,
			description: PropTypes.shape({
				raw: PropTypes.string,
			}).isRequired,
			cta: PropTypes.shape({
				link: PropTypes.string,
				title: PropTypes.string,
			}),
		})
	),
};

export default FeaturedContent;
